import { render, staticRenderFns } from "./DetailTiket.vue?vue&type=template&id=4ff4a4d1&scoped=true&"
import script from "./DetailTiket.vue?vue&type=script&lang=js&"
export * from "./DetailTiket.vue?vue&type=script&lang=js&"
import style0 from "./DetailTiket.scss?vue&type=style&index=0&id=4ff4a4d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff4a4d1",
  null
  
)

export default component.exports